import { render, staticRenderFns } from "./QuoteHeader.vue?vue&type=template&id=81d1e5a8"
import script from "./QuoteHeader.vue?vue&type=script&lang=js"
export * from "./QuoteHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports